<script setup lang="ts">
defineOptions({
  inheritAttrs: false,
});

const props = withDefaults(defineProps<{
  alt?: string;
  decoding?: ImageDecoding;
  fetchpriority?: ImageFetchPriority;
  height?: number | string;
  loading?: ImageLoading;
  preload?: boolean;
  sizes?: string;
  variant?: BrandLogoVariant;
  width?: number | string;
}>(), {
  alt: undefined,
  decoding: "async",
  fetchpriority: "low",
  height: undefined,
  loading: "lazy",
  preload: false,
  sizes: undefined,
  variant: "light",
  width: undefined,
});
type BrandLogoVariant = "dark" | "light" | "ts";
type ImageDecoding = "async" | "auto" | "sync";
type ImageFetchPriority = "auto" | "high" | "low";
type ImageLoading = "eager" | "lazy";

interface BrandLogoAsset {
  alt: string;
  height: number;
  src: string;
  width: number;
}

const brandLogoAssets: Record<BrandLogoVariant, BrandLogoAsset> = {
  dark: {
    alt: "Logo Anggun Praya",
    height: 154,
    src: "https://template.anggunpraya.id/_ipx/_/logo-anggunpraya-dark.webp",
    width: 616,
  },
  light: {
    alt: "Logo Anggun Praya",
    height: 154,
    src: "https://template.anggunpraya.id/_ipx/_/logo-anggunpraya-light.webp",
    width: 616,
  },
  ts: {
    alt: "Anggun Praya",
    height: 226,
    src: "https://template.anggunpraya.id/_ipx/_/logo-anggunpraya-ts.webp",
    width: 1152,
  },
};

const asset = computed(() => brandLogoAssets[props.variant]);

const preloadValue = computed(() => {
  if (!props.preload) {
    return false;
  }

  return {
    fetchPriority: props.fetchpriority,
  };
});
</script>

<template>
  <NuxtImg
    v-bind="$attrs"
    :alt="props.alt ?? asset.alt"
    :decoding="props.decoding"
    :fetchpriority="props.fetchpriority"
    :height="props.height ?? asset.height"
    :loading="props.loading"
    :preload="preloadValue"
    :sizes="props.sizes"
    :src="asset.src"
    :width="props.width ?? asset.width"
  />
</template>
